module.exports = __webpack_public_path__ + "img/figma.ce9d771b.jpg";